<template>
  <div class="base-table">
    <div class="confirmBtnBox">
      <el-button type="primary" v-if="!editSort" @click="editSort = true">
        编辑排序
      </el-button>
      <el-button v-else @click="handleSortEdit" :loading="editSortLoading">
        保存
      </el-button>
    </div>
    <div class="base-table-table">
      <el-table ref="myTable" :data="tableList" style="width: 100%" stripe :cell-class-name="addClass"
        @selection-change="handleSelectionChange">
        <el-table-column type="selection" v-if="mulSelect"></el-table-column>
        <template v-for="(item, index) in tableHeader">
          <el-table-column :prop="item.prop" :label="item.label" :align="'left'" :key="index"
            :width="item.width ? item.width : null">
            <template slot-scope="scope">
              <div v-if="item.label == '租户登录链接'">
                <div class="copy">
                  <p class="httpLink bianque_man">
                    运营管理端:
                    <span ref="bianque_man">
                      https://bianque-man.jd.com/index/?logintype=&tenantId={{ scope.row[item.prop] }}
                    </span>
                  </p>
                  <!-- <span> -->
                  <el-button type="text" size="small" @click="bianque_man('bianque_man', scope.$index)"
                    class="but">复制</el-button>
                  <!-- </span> -->
                </div>
                <div class="copy">
                  <p class="httpLink bianque">
                    创作者端:
                    <span ref="bianque">
                      https://bianque.jd.com/index/?tenantId={{ scope.row[item.prop] }}
                    </span>
                  </p>
                  <!-- <span> -->
                  <el-button type="text" size="small" @click="bianque_man('bianque', scope.$index)"
                    class="but">复制</el-button>
                  <!-- </span> -->
                </div>
              </div>
              <div v-else-if="item.label == '创建时间'">
                <p>{{ scope.row[item.prop] | timeTransform }}</p>
              </div>
              <div v-else-if="item.label == '更新时间'">
                <p>{{ scope.row[item.prop] | timeTransform }}</p>
              </div>
              <div v-else-if="item.label == '后台截图'">
                <img :src="scope.row[item.prop]" />
              </div>
              <div v-else-if="item.label == '任务名称' && item.tableStatus == 'taskName'
              ">
                <p>{{ scope.row.contentExtend && scope.row.contentExtend[item.prop] || '--' }}</p>
              </div>
              <div v-else-if="item.label == '任务要求' && item.tableStatus == 'taskDesc'
              ">
                <p>{{ scope.row.contentExtend && scope.row.contentExtend[item.prop] || '--' }}</p>
              </div>
              <div v-else-if="item.label == '悬赏金额' && item.tableStatus == 'taskRewardDesc'
              ">
                <p>{{ scope.row.contentExtend && scope.row.contentExtend[item.prop] || '--' }}</p>
              </div>
              <div v-else-if="item.label == '平台' && item.tableStatus == 'dicCode'
              ">
                <p>{{ scope.row[item.prop] | dicCodeStatus }}</p>
              </div>
              <div v-else-if="item.label == '状态' && item.tableStatus == undefined
              ">
                <p>{{ scope.row[item.prop] }}</p>
              </div>
              <div v-else-if="item.label == '头像' && item.tableStatus == 'headPic'
              ">
                <img :src="getHeadPic(scope.row, item.prop)" alt="" />
              </div>
              <div v-else-if="item.label == '个人简介' && item.tableStatus == 'briefing'
              ">
                <p>{{ getBriefing(scope.row, item.prop) }}</p>
              </div>
              <div v-else-if="item.label == '状态' && item.tableStatus == 'tenantStatus'
              ">
                <p>{{ scope.row[item.prop] | tenantStatus }}</p>
              </div>
              <div v-else-if="item.label == '审核时间' && item.tableStatus == 'auditTime'
              ">
                <p>{{ scope.row[item.prop] ? new Date(scope.row[item.prop]).toLocaleString(undefined, { hour12: false })
                  : '--' }}</p>
              </div>
              <div v-else-if="item.label == '审核人' && item.tableStatus == 'auditUser'
              ">
                <p>{{ scope.row[item.prop] || '--' }}</p>
              </div>
              <div v-else-if="item.label == '提交时间' && item.tableStatus == 'createTime'
              ">
                <p>{{ new Date(scope.row[item.prop]).toLocaleString(undefined, { hour12: false }) }}</p>
              </div>
              <div v-else-if="item.label == '文章ID' && item.tableStatus == 'contentId'
              ">
                <p>{{ getContent(scope.row, item.prop) }}</p>
              </div>
              <div v-else-if="item.label == '健康内容平台作品名称' && item.tableStatus == 'contentName'
              ">
                <p>{{ getContent(scope.row, item.prop) }}</p>
              </div>
              <div v-else-if="item.label == '第三方平台作品名称' && item.tableStatus == 'externalContentName'
              ">
                <p>{{ getContent2(scope.row, item.prop) }}</p>
              </div>
              <div v-else-if="item.label == '搬运状态' && item.tableStatus == 'carryStatus'
              ">
                <p>{{ getCarryStatus(scope.row) }}</p>
              </div>
              <div v-else-if="item.label == '作品类型' && item.tableStatus == 'contentType'
              ">
                <p>{{ getContentType(scope.row, item.prop) || '未获取成功' }}</p>
              </div>
              <div v-else-if="item.label == '搬运时间' && item.tableStatus == 'startTime'
              ">
                <p>{{ scope.row[item.prop] ? new Date(scope.row[item.prop]).toLocaleString(undefined, { hour12: false })
                  : '-' }}</p>
              </div>
              <div v-else-if="item.label == '反馈时间' && (item.tableStatus == 'oldestFeedbackTime' || item.tableStatus == 'createTime')
              ">
                <p>{{ scope.row[item.prop] ? new Date(scope.row[item.prop]).toLocaleString(undefined, { hour12: false })
                  : '-' }}</p>
              </div>
              <div v-else-if="item.label == '审核时间' && item.tableStatus == 'processTime'
              ">
                <p>{{ scope.row[item.prop] ? new Date(scope.row[item.prop]).toLocaleString(undefined, { hour12: false })
                  : '-' }}</p>
              </div>
              <div v-else-if="item.label == '状态' && (item.tableStatus == 'processType' || item.tableStatus == 'operationProcessType')
              ">
                <p>{{ scope.row[item.prop] !== undefined ? ['', '不做处理', '下线内容'][scope.row[item.prop]] : '未处理' }}</p>
              </div>
              <div v-else-if="item.label == '审核人' && item.tableStatus == 'processUser'
              ">
                <p>{{ scope.row[item.prop] || '-' }}</p>
              </div>
              <div v-else-if="item.label == '状态' && item.tableStatus == 'auditStatus'
              ">
                <!-- <p v-if="activeName === 'pending' || activeName === 'rejected'">{{ scope.row[item.prop] | auditStatus }}</p> -->
                <p>{{ scope.row[item.prop] | auditStatus }}</p>

              </div>
              <!-- <div v-else-if="item.label === '状态'">
                <p>{{ scope.row[item.prop] }}</p>
              </div> -->
              <div v-else-if="item.label == '文章标题'">
                <p><span class="choiceness" v-show="scope.row.badge === 2 ? true : false">精</span> {{
                  scope.row[item.prop] }}</p>
              </div>

              <div v-else-if="item.label == 'labelLevel'">
                <p>{{ `${changeNumToHan(scope.row[item.prop])}级标签` }}</p>
              </div>
              <div v-else-if="item.prop == 'level'">
                <p>{{ `${changeNumToHan(scope.row[item.prop])}级索引` }}</p>
              </div>
              <div v-else-if="item.label == '身份'">
                <p>{{ scope.row[item.prop] | identity }}</p>
              </div>
              <div v-else-if="item.label == '所属租户'">
                <p>{{ scope.row[item.prop] | isTenant }}</p>
              </div>
              <div v-else-if="item.label == '租户类型'">
                <p>{{ scope.row[item.prop] | isTenant }}</p>
              </div>
              <div v-else-if="item.label == '账号类型'">
                <p>{{ scope.row[item.prop] | isPin }}</p>
              </div>
              <div v-else-if="item.label == '文章类型'">
                <p>{{ scope.row[item.prop] | articlesType }}</p>
              </div>
              <div v-else-if="item.label == '角色'">
                <p>{{ scope.row[item.prop] }}</p>
              </div>
              <div v-else-if="item.label == 'ERP或京东PIN'">
                <p>{{ scope.row[item.prop].pin }}</p>
              </div>
              <div v-else-if="item.label == '所属业务'">
                <p>{{ scope.row[item.prop].name }}</p>
              </div>
              <div v-else-if="item.label == '后台截图'">
                <img :src="scope.row[item.prop]" />
              </div>
              <div v-else-if="item.label == '权重'">
                <el-input-number :min="0" v-model="scope.row[item.prop]" controls-position="right" class="inputSort"
                  :disabled="!editSort" v-if="editSort" />
                <p v-else>{{ scope.row[item.prop] }}</p>
              </div>
              <div v-else>
                <p>{{ scope.row[item.prop] }}</p>
              </div>
            </template>
          </el-table-column>
        </template>
        <template v-if="tableType !== 0">
          <el-table-column align="center" label="操作" width="150">
            <template slot-scope="scope">
              <div v-if="tableType == 1">
                <!-- <el-button @click="handleClick(scope.row,'')" type="text" size="small">编辑</el-button>
                <span class="border"></span> -->
                <el-button type="text" size="small" @click="handleClick(scope.row)">取消管理员权限</el-button>
              </div>
              <div v-else-if="tableType == 2">
                <el-button @click="handleClick(scope.row)" type="text" size="small">管理子集</el-button>
              </div>
              <div v-else-if="tableType == 3">
                <el-button @click="handleClick(scope.row, 'edit')" type="text" size="small">编辑</el-button>
                <span class="border"></span>
                <el-button type="text" size="small" @click="handleClick(scope.row, 'goAdmin')">租户管理员</el-button>
                <span class="border" v-if="scope.row.tenantStatus === 1"></span>
                <el-button type="text" size="small" @click="cancelAdmin(scope.row)"
                  v-if="scope.row.tenantStatus === 1">取消用户权限</el-button>
              </div>
              <div v-else-if="tableType == 4">
                <el-button @click="handleClick(scope.row, 'edit')" type="text" size="small">编辑</el-button>
                <span class="border"></span>
                <el-button type="text" size="small" @click="handleClick(scope.row, 'goAdmin')">标签管理

                  <!-- v-if="scope.row.labelLevel !== 3 || !scope.row.labelLevel" -->
                </el-button>
                <span class="border"></span>

                <!-- v-if="scope.row.labelLevel !== 3 || !scope.row.labelLevel" -->
                <el-button type="text" size="small" @click="handleClick(scope.row, 'moveLabel')"
                  v-if="scope.row.labelLevel >= 1">
                  移动
                  <!--  -->
                </el-button>
                <span class="border" v-if="scope.row.labelLevel >= 1"></span>

                <!-- v-if="(scope.row.labelLevel <= 3 || !scope.row.labelLevel) && scope.row.labelLevel >= 1" -->
                <el-button type="text" size="small" @click="handleClick(scope.row, 'mergeLabel')"
                  v-if="scope.row.labelLevel >= 1">
                  合并
                  <!-- v-if="(scope.row.labelLevel <= 3 || !scope.row.labelLevel) && scope.row.labelLevel >= 1" -->
                </el-button>
                <span class="border" v-if="scope.row.labelLevel >= 1"></span>
                <!-- v-if="(scope.row.labelLevel <= 3 || !scope.row.labelLevel) && scope.row.labelLevel >= 1" -->
                <el-button type="text" size="small" @click="handleClick(scope.row, 'delete')">删除
                </el-button>
                <span class="border" v-if="shuType == 1"></span>
                <el-button type="text" size="small" v-if="shuType == 1" @click="handleClick(scope.row, 'attribute')">属性
                </el-button>
              </div>
              <div v-else-if="tableType == 5">
                <el-button @click="handleClick(scope.row, 'edit')" type="text" size="small">编辑</el-button>
                <span class="border" v-if="scope.row.labelLevel !== 2 || !scope.row.labelLevel"></span>
                <el-button type="text" size="small" @click="handleClick(scope.row, 'delete')">删除</el-button>
              </div>
              <div v-else-if="tableType == 6">
                <el-button @click="handleClick(scope.row, 'edit')" type="text" size="small">编辑</el-button>
                <span class="border"></span>
                <el-button type="text" size="small" @click="handleClick(scope.row, 'goAdmin')"
                  v-if="scope.row.labelLevel !== 2 || !scope.row.labelLevel">频道管理</el-button>
                <span class="border" v-if="scope.row.labelLevel !== 2 || !scope.row.labelLevel"></span>
                <el-button type="text" size="small" @click="handleClick(scope.row, 'delete')">删除</el-button>
              </div>
              <div v-else-if="tableType == 7">
                <!-- {{ scope.row.auditStatus  }}
                {{scope.row.accountStatus}} -->
                <el-button @click="handleClick(scope.row, 'audit')" type="text" size="small"
                  v-if="scope.row.auditStatus == 1 || scope.row.auditStatus == 0">审核</el-button>
                <el-button type="text" size="small" v-if="scope.row.auditStatus !== 1 &&
                  scope.row.auditStatus !== 3 &&
                  scope.row.auditStatus !== 0 &&
                  scope.row.accountStatus !== 3
                " :disable="scope.row.accountStatus == 2" @click="handleClick(scope.row, 'editrole')">修改角色
                  <span class="border" v-show="isFreezeShow"></span>
                </el-button>
                <el-button type="text" size="small" v-if="scope.row.accountStatus == 3 || scope.row.auditStatus == 3
                " @click="handleClick(scope.row, 'examine')">查看理由
                  <span class="border" v-show="isFreezeShow"></span>
                </el-button>
                <el-button type="text" size="small" v-if="scope.row.auditStatus !== 1 &&
                  scope.row.auditStatus !== 3 &&
                  scope.row.auditStatus !== 0 &&
                  scope.row.accountStatus !== 1
                " :disabled="scope.row.accountStatus == 3" @click="handleClick(scope.row, 'freeze')">冻结
                </el-button>
                <el-button type="text" size="small" v-if="
                  // scope.row.auditStatus === 4 &&
                  // scope.row.auditStatus === 2 &&
                  scope.row.auditStatus != 1 &&
                  scope.row.auditStatus != 3 &&
                  scope.row.accountStatus != 1
                " :disabled="scope.row.accountStatus !== 3" @click="handleClick(scope.row, 'thaw')">解冻
                </el-button>
              </div>
              <!--  accountStatus 1：未生效  2：正常   3：冻结   auditStatus: 1：待审核；2：通过；3：驳回   -->
              <div v-else-if="tableType == 8">
                <el-button @click="handleClick(scope.row, 'edit')" type="text" size="small">编辑</el-button>
                <span class="border"></span>
                <el-button type="text" size="small" @click="handleClick(scope.row, 'delete')">删除</el-button>
              </div>
              <div v-else-if="tableType == 9">
                <el-button @click="handleClick(scope.row, 'edit')" type="text" size="small">编辑</el-button>
                <span class="border"></span>
                <el-button type="text" size="small" @click="handleClick(scope.row, 'sort')"
                  v-if="scope.row.labelLevel !== 2 || !scope.row.labelLevel">排序</el-button>
                <span class="border" v-if="scope.row.labelLevel !== 2 || !scope.row.labelLevel"></span>
                <el-button type="text" size="small" @click="handleClick(scope.row, 'delete')">删除</el-button>
              </div>
              <div v-else-if="tableType == 10">
                <el-button @click="handleClick(scope.row, 'edit')" type="text" size="small"
                  v-if="[3, 4, 5].indexOf(scope.row.articleStatus) > -1">编辑</el-button>
                <span class="border" v-if="scope.row.articleStatus == 2 && scope.row.articleStatus == 3
                "></span>
                <el-button type="text" size="small" @click="handleClick(scope.row, 'review')"
                  v-if="scope.row.articleStatus == 2">审核</el-button>
                <span class="border" v-if="scope.row.articleStatus == 3"></span>
                <el-button type="text" size="small" @click="handleClick(scope.row, 'featured')"
                  v-if="scope.row.articleStatus == 3">{{ scope.row.badge === 2 ? '取消精选' : '设置精选' }}</el-button>
                <span class="border" v-if="scope.row.articleStatus == 3"></span>
                <el-button type="text" size="small" @click="handleClick(scope.row, 'watchOnline')"
                  v-if="scope.row.articleStatus == 3">查看线上</el-button>
                <span class="border" v-if="scope.row.articleStatus == 3"></span>
                <el-button type="text" size="small" @click="handleClick(scope.row, 'offline')"
                  v-if="scope.row.articleStatus == 3">下线</el-button>
                <span class="border" v-if="(scope.row.articleStatus == 4 ||
                  scope.row.articleStatus == 5) &&
                  scope.row.articleStatus == 3
                "></span>
                <el-button type="text" size="small" @click="handleClick(scope.row, 'reason')" v-if="scope.row.articleStatus == 4 || scope.row.articleStatus == 5
                ">查看理由</el-button>
                <span class="border" v-if="scope.row.articleStatus == 7 &&
                  (scope.row.articleStatus == 5 ||
                    scope.row.articleStatus == 4)
                "></span>
                <el-button type="text" size="small" @click="handleClick(scope.row, 'offlineApplication')"
                  v-if="scope.row.articleStatus == 7">审核下线申请</el-button>

                <span class="border" v-if="scope.row.articleStatus == 3"></span>
                <el-button type="text" size="small" @click="handleClick(scope.row, 'top')"
                  v-if="scope.row.articleStatus == 3">{{ scope.row.isTop === 0 ? '设置置顶' : '取消置顶' }}</el-button>
              </div>
              <div v-else-if="tableType == 11">
                <el-button type="text" size="small" @click="handleClick(scope.row, 'check')">查看</el-button>
                <span class="border"></span>
                <el-button type="text" size="small" @click="handleClick(scope.row, 'recompose')">修改</el-button>
                <span class="border"></span>
                <el-button type="text" size="small" @click="handleClick(scope.row, 'delete')">删除</el-button>
              </div>
              <div v-else-if="tableType == 12">
                <el-button @click="handleClick(scope.row, 'edit')" type="text" size="small">编辑</el-button>

                <span class="border"></span>

                <el-button type="text" size="small" @click="handleClick(scope.row, 'indexOperate')">
                  标签管理
                </el-button>
                <span class="border"></span>

                <el-button type="text" size="small" @click="handleClick(scope.row, 'delete')">删除
                </el-button>
              </div>
              <div v-else-if="tableType == 13">
                <el-button @click="handleClick(scope.row, 'preview')" type="text" size="small"
                  v-if="scope.row.resultStatus == 1">预览</el-button>

                <el-button type="text" size="small" @click="handleClick(scope.row, 'recarry')"
                  v-if="scope.row.resultStatus == 0 && scope.row.type == 2">
                  重新搬运
                </el-button>

              </div>
              <div v-else-if="tableType == 14">
                <!-- {{ scope.row.auditStatus  }}
                {{scope.row.accountStatus}} -->
                <el-button @click="handleClick(scope.row, 'audit')" type="text" size="small"
                  v-if="scope.row.auditStatus == 1 || scope.row.auditStatus == 0">审核</el-button>
                <el-button type="text" size="small" v-if="scope.row.auditStatus == 4 ||
                  scope.row.auditStatus == 3
                " @click="handleClick(scope.row, 'examine')">查看理由
                  <span class="border" v-show="isFreezeShow"></span>
                </el-button>
                <el-button type="text" size="small" v-if="scope.row.auditStatus === 2 ||
                  scope.row.auditStatus === 0
                " @click="handleClick(scope.row, 'freeze')">冻结
                </el-button>
                <el-button type="text" size="small" v-if="scope.row.auditStatus === 4
                " @click="handleClick(scope.row, 'thaw')">解冻
                </el-button>
              </div>
              <div v-else-if="tableType == 15">
                <el-button @click="handleClick(scope.row, 'edit')" type="text" size="small"
                  v-if="[3, 4, 5].indexOf(scope.row.articleStatus) > -1">编辑</el-button>
                <span class="border" v-if="scope.row.articleStatus == 2 && scope.row.articleStatus == 3
                "></span>
                <el-button type="text" size="small" @click="handleClick(scope.row, 'review')"
                  v-if="scope.row.articleStatus == 2">审核</el-button>
                <span class="border" v-if="scope.row.articleStatus == 3"></span>
                <el-button type="text" size="small" @click="handleClick(scope.row, 'featured')"
                  v-if="scope.row.articleStatus == 3">{{ scope.row.badge === 2 ? '取消精选' : '设置精选' }}</el-button>
                <span class="border" v-if="scope.row.articleStatus == 3"></span>
                <el-button type="text" size="small" @click="handleClick(scope.row, 'watchOnline')"
                  v-if="scope.row.articleStatus == 3">查看线上</el-button>
                <span class="border" v-if="scope.row.articleStatus == 3"></span>
                <el-button type="text" size="small" @click="handleClick(scope.row, 'reason')" v-if="scope.row.articleStatus == 4 || scope.row.articleStatus == 5
                ">查看理由</el-button>
              </div>
              <div v-else-if="tableType == 16">
                <el-button type="text" size="small" @click="handleClick(scope.row, 'review')"
                  v-if="scope.row.processStatus == 0">审核</el-button>

                <el-button type="text" size="small" @click="handleClick(scope.row, 'reason')"
                  v-if="scope.row.processRemark && scope.row.processStatus == 1">查看理由</el-button>
              </div>
              <div v-else-if="tableType == 111">
                <!-- <el-button
                  type="text"
                  size="small"
                  @click="handleClick(scope.row, 'review')"
                  >设置主视频</el-button
                > -->
                <el-button type="text" size="small" @click="handleClick(scope.row, 'posttop')"
                  v-if="scope.row.auditStatus == 1">置顶</el-button>
                <el-button type="text" size="small" @click="handleClick(scope.row, 'check')">查看详情</el-button>
                <el-button type="text" size="small" @click="handleClick(scope.row, 'postpass')"
                  v-if="scope.row.auditStatus == 0 || scope.row.auditStatus == 2">审核通过</el-button>
                <el-button type="text" size="small" @click="handleClick(scope.row, 'postdeny')"
                  v-if="scope.row.auditStatus == 0 || scope.row.auditStatus == 1">审核拒绝</el-button>
              </div>
              <div v-else-if="tableType == 222">
                <!-- <el-button
                  type="text"
                  size="small"
                  @click="handleClick(scope.row, 'posttop')"
                  v-if="scope.row.auditStatus == 1"
                  >置顶</el-button
                > -->
                <el-button type="text" size="small" @click="handleClick(scope.row, 'preSetTop')">{{
                  (globalTenantId == 484 || globalTenantId == 492) && scope.row.isCommunityTop ||
                    (globalTenantId == 290 || globalTenantId == 287) && scope.row.isAppTop
                    ?
                    '取消置顶' : '置顶' }}</el-button>
              </div>
            </template>
          </el-table-column>
        </template>
      </el-table>
    </div>
  </div>
</template>

<script>
var env_mode = process.env.TYPE;
import { jdh_qz_man_post_change, jdh_qz_man_update_post_top_score } from "@/api/indexs";
import { jdh_qz_man_add_post_top } from "../../../../../api/community";
import { jdh_qz_man_cancel_post_top } from "../../../../../api/community";
import { getBusinessId } from "../../../../../utils/enum"
// import images from "../assets/";
export default {
  name: 'circleTable',
  props: {
    tableData: {
      default: () => {
        return {
          tableList: Array, // 列表
          tableHeader: Array, // 表头
          tableType: Number, // 操作按钮
          shuType: Number,
        }
      }
    },
    isFreezeShow: {
      default: () => {
        return true
      },
      type: Boolean
    },
    activeName: {
      default: () => {
        return ''
      },
      type: String
    },
    mulSelect: {
      default: () => {
        return false
      },
      type: Boolean
    }
  },
  // [ 'tableData' ],
  data() {
    return {
      images: "../assets/default-header.png",
      selectedRows: [],
      tableList: [],
      tableHeader: [],
      tableType: '',
      shuType: '',
      env_mode,
      dirt: {
        1: '图文',
        7: '视频',
        8: '疾病百科',
        9: "症状百科",
        11: "问答",
        13: "药品百科",
      },
      editSort: false,
      editSortLoading: false,
      globalTenantId: this.$route.query.tenantid
    }
  },
  mounted() {
    const $el = document.querySelectorAll('.el-cascader-panel .el-cascader-node[aria-owns]');
    Array.from($el).map(item => item.removeAttribute("aria-owns"));
  },
  methods: {
    getHeadPic(row, key) {
      if (row.contentUser && row.contentUser[key]) {
        return `//image.healthjd.com/da/${row.contentUser[key]}`;
      } else {
        return ''
      }
    },
    getBriefing(row, key) {
      if (row.contentUser && row.contentUser[key]) {
        return row.contentUser[key];
      } else {
        return ''
      }
    },
    getCarryStatus(row) {
      /**
       * runStatus: 运行状态 1, "待执行" 2, "执行中" 3, "已完成"
       * resultStatus: 结果状态 1成功，0失败
       */
      if (row.runStatus === 3) {
        if (row.resultStatus === 1) {
          return '搬运成功'
        } else {
          return '搬运失败'
        }
      } else if (row.runStatus === 1) {
        return '待执行'
      } else if (row.runStatus === 2) {
        return '执行中'
      }
    },
    getContentType(row, key) {
      try {
        return this.dirt[row.taskRecordResult.contentBizDTO[key]] || '';
      } catch (error) {
        return ''
      }
    },
    getContent(row, key) {
      console.log("🚀 ~ file: baseTable.vue:612 ~ getContent ~ row, key:", row, key)
      try {
        return row.taskRecordResult.contentBizDTO[key] || '未获取成功'
      } catch (error) {
        return '未获取成功'
      }
    },
    getContent2(row, key) {
      if (row.taskRecordResultDetail && row.taskRecordResultDetail.data) {
        try {
          const json = JSON.parse(row.taskRecordResultDetail.data);
          console.log("🚀 ~ file: baseTable.vue:770 ~ getContent2 ~ json:", json)
          return json[key] || '未获取成功';
        } catch (error) {
          console.log("🚀 ~ file: baseTable.vue:772 ~ getContent2 ~ error:", error)
          return '未获取成功'
        }
      } else {
        return '未获取成功'
      }
    },
    bianque_man(refName, index) {

      // let a = document.getElementsByClassName('.bianque')
      //
      // document.execCommand("copy")
      // document.body.removeChild(this.$refs[refName][index].innerText);
      // this.$message.success('复制成功')
      var aux = document.createElement('input')
      aux.setAttribute('value', this.$refs[refName][index].innerText)
      document.body.appendChild(aux)
      aux.select()
      document.execCommand('copy')
      document.body.removeChild(aux)
      this.$message.success('复制成功')
    },
    handleClick(val, type) {
      console.log("valvvvvvv", val, type)
      if (val && type == 'preSetTop') {
        console.log('置顶');
        if (this.globalTenantId == 484 || this.globalTenantId == 492) {
          this.setStatus({
            tenantId: parseInt(this.globalTenantId),
            businessId: this.getBusinessId(parseInt(this.globalTenantId)),
            updateInfo: [{
              postId: val.postId,
              isCommunityTop: val.isCommunityTop ? 0 : 1
            }]
          })
        } else if (this.globalTenantId == 287 || this.globalTenantId == 290) {
          val.isAppTop ?
            jdh_qz_man_cancel_post_top({
              postId: val.postId,
              businessId: this.getBusinessId(parseInt(this.globalTenantId)),
              tenantId: parseInt(this.globalTenantId),
              communityId: val.communityId,
            }).then(() => {
              this.$message.success("取消置顶成功")
              this.$emit('handleClick', {
                val: {},
                type: "",
              })
            })
            :
            jdh_qz_man_add_post_top({
              postId: val.postId,
              businessId: this.getBusinessId(parseInt(this.globalTenantId)),
              tenantId: parseInt(this.globalTenantId),
              communityId: val.communityId,
              communityType: val.communityType
            }).then(() => {
              this.$message.success("置顶成功")
            })
        }

        return;
      }
      let data = {
        val,
        type: type,
      }
      this.$emit('handleClick', data)
    },
    cancelAdmin(val) {
      this.$emit('cancelAdmin', val)
    },
    addClass({ row, column, rowIndex, columnIndex }) {
      if (columnIndex == 1) {
        return 'badge'
      }
    },
    changeNumToHan(num) {
      var arr1 = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九']
      var arr2 = ['', '十', '百', '千', '万', '十', '百', '千', '亿', '十', '百', '千', '万', '十', '百', '千', '亿']
      if (!num || isNaN(num)) return '零'
      var english = num.toString().split('')
      var result = ''
      for (var i = 0; i < english.length; i++) {
        var des_i = english.length - 1 - i// 倒序排列设值
        result = arr2[i] + result
        var arr1_index = english[des_i]
        result = arr1[arr1_index] + result
      }
      result = result.replace(/零(千|百|十)/g, '零').replace(/十零/g, '十') // 将【零千、零百】换成【零】 【十零】换成【十】
      result = result.replace(/零+/g, '零') // 合并中间多个零为一个零
      result = result.replace(/零亿/g, '亿').replace(/零万/g, '万') // 将【零亿】换成【亿】【零万】换成【万】
      result = result.replace(/亿万/g, '亿') // 将【亿万】换成【亿】
      result = result.replace(/零+$/, '') // 移除末尾的零
      // 将【一十】换成【十】
      result = result.replace(/^一十/g, '十')
      return result
    },
    handleSelectionChange(val) {
      console.log('value', val)
      this.selectedRows = val;
      this.$emit('selectedRows', val);
    },
    selectAllRows() {
      this.$refs.myTable.toggleAllSelection();
    },
    getBusinessId(key) {
      return getBusinessId(key)
    },
    async setStatus(params) {
      if (this.globalTenantId == 484 || this.globalTenantId == 492) {
        // 更新置顶-夜谜
        const res = await jdh_qz_man_post_change(params);
        await this.$emit('handleClick', {
          val: {},
          type: "",
        })
        return res;
      } else if (this.globalTenantId == 287 || this.globalTenantId == 290) {
        // 更新置顶-健康app
        const res = await jdh_qz_man_update_post_top_score(params);
        await this.$emit('handleClick', {
          val: {},
          type: "",
        })
        return res;
      }
      this.$emit('handleClick', {
        val: {},
        type: "",
      })
    },
    concelEditSort() {
      this.editSort = false;
    },
    async handleSortEdit() {
      // 置顶-夜谜
      this.editSortLoading = true;
      console.log(this.tableList);
      const updateInfo = (this.tableList || []).map((item) => ({
        postId: item.postId,
        communityTopSort: item?.appTopScore || item?.communityTopSort
      })).filter((item) => (item?.appTopScore >= 0 || item?.communityTopSort >= 0));
      if (this.globalTenantId == 484 || this.globalTenantId == 492) {
        // 精选-夜谜
        const params = {
          tenantId: parseInt(this.globalTenantId),
          businessId: this.getBusinessId(parseInt(this.globalTenantId)),
          updateInfo
        }
        const res = await this.setStatus(params);
        console.log('handleSortEdit', res)
        if (res) {
          this.editSort = false;
        }
      } else if (this.globalTenantId == 287 || this.globalTenantId == 290) {
        // 精选-健康app
        const seen = new Set();
        let hasDuplicates = 0;
        const params = {
          tenantId: parseInt(this.globalTenantId),
          businessId: this.getBusinessId(parseInt(this.globalTenantId)),
          postIds: updateInfo.map((i) => i.postId),
          scores: updateInfo.map((i) => {
            const num = i.communityTopSort;
            // 过滤掉 0
            if (num !== 0) {
              // 检查是否已经出现过
              if (seen.has(num)) {
                hasDuplicates = num; // 找到重复值
              } else {
                seen.add(num); // 记录该值
              }
            }
            return num; // 返回有效的 rankNum
          })
        }
        console.log('handleSortEdit', params)
        if (hasDuplicates !== 0) {
          this.$message({
            message: `有重复权重：${hasDuplicates}`,
            type: 'error'
          })
        } else {
          const res = await this.setStatus(params);
          console.log('handleSortEdit', res)
          if (res) {
            this.editSort = false;
          }
        }
      }
      this.editSortLoading = false;
    }
  },
  created() {
    if (this.tableData) {
      var { tableList, tableHeader, tableType, shuType, general } = this.tableData
      console.log("tableHeader", tableHeader)
    }
    this.tableList = tableList || [];
    this.tableHeader = tableHeader || [];
    this.tableType = tableType || 0;
    this.shuType = shuType;
  },

  filters: {
    dicCodeStatus: function (data) {
      switch (data) {
        case '12':
          return '抖音'
        case '13':
          return '快手'
        case '14':
          return '微博'
        case '15':
          return 'b站'
        case '16':
          return '西瓜'
        default:
          return data
      }
    },
    tenantStatus: function (data) {
      switch (data) {
        case 1:
          return '正常'
        case 2:
          return '已失效'
        default:
          return data
      }
    },
    auditStatus: function (data) {
      switch (data) {
        case 0:
          return '未认证'
        case 1:
          return '待审核'
        case 2:
          return '通过'
        case 3:
          return '驳回'
        case 4:
          return '冻结'
        default:
          return data
      }
    },
    isPin: function (data) {
      switch (data) {
        case 1:
          return 'ERP账号'
        case 2:
          return 'JD账号'
        case 3:
          return '其他账号'
        default:
          return data
      }
    },
    isTenant: function (data) {
      switch (data) {
        case 1:
          return '内部租户'
        case 2:
          return '私域租户'
        case 3:
          return '非私域外部租户'
        default:
          return data
      }
    },
    identity: function (data) {
      switch (data) {
        case 0:
          return '未知'
        case 1:
          return '写手'
        case 2:
          return '医护'
        case 3:
          return '运营'
        default:
          return data
      }
    },
    articlesType: function (data) {
      switch (data) {
        case 1:
          return '图文'
        case 2:
          return '搭配'
        case 3:
          return '京装'
        case 4:
          return '帮助'
        case 5:
          return '单空间'
        case 6:
          return '整层'
        case 7:
          return '视频'
        case 8:
          return '疾病百科'
        case 9:
          return '症状百科'
        case 10:
          return '文章子文章'
        case 11:
          return '问答'
        case 15:
          return '回答'
      }
    }
  }
}
</script>

<style scoped lang="scss">
.httpLink {
  width: 152px;
  font-size: 12px;
  color: #5d6072;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.copy {
  display: flex;
  align-items: center;

  .but {
    width: 24px;
  }

  .httpLink {
    flex: 1;
  }
}

.images {
  width: 50px;
  height: 50px;

  // margin: 0 auto;
  &>img {
    border-radius: 50%;
    width: 100%;
    height: 100%;
  }
}

.badge {
  color: red;
}

.choiceness {
  color: #fff;
  background-color: red;
}

.noColor {
  color: #c0c4cc
}

.cell {
  font-size: 13px;
  color: rgba(93, 96, 114, 1);
  overflow: visible !important;
}

.confirmBtnBox {
  padding: 20px 0;
  display: flex;
  justify-content: flex-end;
}

.inputSort {
  width: 100%;
}
</style>
